/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccessCheckResult,
  AdminInit,
  AuthProviderConfigCreate,
  AuthProviderConfigUpdate,
  AuthProviderResponse,
  AuthProviderType,
  BodyLoginForAccessTokenApiAuthTokenPost,
  BodyUpdateDocumentFileApiDocumentsDocumentIdFilePut,
  BodyUpdateDocumentPermissionsApiDocumentsDocumentIdPermissionsPut,
  BodyUploadDocumentApiDocumentsUploadPost,
  ChatConfigRequest,
  ChatConfigResponse,
  ChatConfigTest,
  ChatHistoryEntryOutput,
  ChatProviderResponse,
  ChatRequest,
  ChatResponse,
  ConversationDetails,
  ConversationSummary,
  CreateConversationRequest,
  Document,
  DocumentCreate,
  DocumentListResponse,
  DocumentSortBy,
  DocumentSourceProviderConfigRequest,
  DocumentSourceProviderConfigResponse,
  DocumentSourceSyncStatsResponse,
  DocumentSourceUserConnectionRequest,
  DocumentSourceUserConnectionResponse,
  EmailVerification,
  EmbeddingConfigRequest,
  EmbeddingConfigResponse,
  EmbeddingProviderResponse,
  EmbeddingTestResponse,
  FAQDocumentCreate,
  FAQDocumentResponse,
  FAQDocumentUpdate,
  FAQListResponse,
  FAQSearchResponse,
  FAQSortBy,
  FAQStatsResponse,
  FAQStatus,
  FAQStatusUpdate,
  FolderSync,
  FolderSyncCreate,
  FolderSyncUpdate,
  Group,
  GroupCreate,
  GroupListResponse,
  GroupMemberListResponse,
  GroupMemberUpdate,
  GroupRequest,
  GroupRequestApproval,
  GroupRequestCreate,
  GroupRequestListResponse,
  GroupStatus,
  GroupType,
  GroupUpdate,
  GroupVisibility,
  HTTPValidationError,
  MemberRole,
  MemberStatus,
  OrganizationUpdate,
  PaginatedResponseConversationSummary,
  PaginatedResponseMessageResponse,
  PasswordChangeRequest,
  PasswordReset,
  PasswordResetConfirm,
  PublicSharePointLinkRequest,
  PublicSharePointSyncRequest,
  QdrantCollectionResponse,
  SMTPConfigRequest,
  SMTPConfigResponse,
  SMTPConfigurationResponse,
  SearchRequest,
  SearchResponse,
  SetPrimaryProviderRequest,
  SettingsUpdate,
  SharedFolderImportRequest,
  SharedFolderValidateRequest,
  StatusResponse,
  SystemCleanupResponse,
  SystemStatusResponse,
  TestEmailRequest,
  TextExtractionRequest,
  TextExtractionResponse,
  UpdateConversationRequest,
  User,
  UserChatPreference,
  UserCreate,
  UserRegister,
  UserUpdate,
  ValidateFolderUrlRequest,
  ValidateFolderUrlResponse,
  WhoAmIResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Health check endpoint.
   *
   * @tags Public
   * @name HealthCheckApiHealthGet
   * @summary Health Check
   * @request GET:/api/health
   */
  healthCheckApiHealthGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/health`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get system version information.
   *
   * @tags Public
   * @name GetVersionApiVersionGet
   * @summary Get Version
   * @request GET:/api/version
   */
  getVersionApiVersionGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/version`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Check if at least one admin user exists in the system.
   *
   * @tags Public
   * @name AdminExistsApiAdminExistsGet
   * @summary Admin Exists
   * @request GET:/api/admin-exists
   */
  adminExistsApiAdminExistsGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/admin-exists`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Initialize the system with an admin user. This endpoint can only be used if no users exist in the system.
   *
   * @tags Public
   * @name InitializeSystemApiInitPost
   * @summary Initialize System
   * @request POST:/api/init
   */
  initializeSystemApiInitPost = (data: AdminInit, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/init`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get list of available authentication providers for login. This is a public endpoint that doesn't require authentication.
   *
   * @tags Public
   * @name GetAvailableAuthProvidersApiAuthProvidersGet
   * @summary Get Available Auth Providers
   * @request GET:/api/auth-providers
   */
  getAvailableAuthProvidersApiAuthProvidersGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/auth-providers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get public Entra configuration for frontend MSAL initialization. Returns only non-sensitive config like tenant_id and client_id.
   *
   * @tags Public
   * @name GetEntraConfigApiAuthEntraConfigGet
   * @summary Get Entra Config
   * @request GET:/api/auth/entra/config
   */
  getEntraConfigApiAuthEntraConfigGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/auth/entra/config`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Endpoint to receive Content Security Policy (CSP) violation reports. This endpoint is called by the browser when CSP violations occur. It logs the violations for security monitoring and investigation. **EXEMPT FROM CSRF:** Browser-generated reports, not user requests. CSP violations can indicate: - XSS attack attempts - Malicious browser extensions - Misconfigured CSP policies - Third-party script issues Args: request: FastAPI Request object containing the CSP violation report Returns: Response: 204 No Content (standard for CSP report endpoints) Security Notes: - This endpoint is exempt from CSRF protection (browser reports) - Does not require authentication (browser reports) - Logs violations for security monitoring - Always returns 204 No Content (per CSP spec)
   *
   * @tags Security, security
   * @name CspViolationReportApiCspViolationReportPost
   * @summary Csp Violation Report
   * @request POST:/api/csp-violation-report
   */
  cspViolationReportApiCspViolationReportPost = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/csp-violation-report`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get recommended security headers configuration. This endpoint provides information about security headers that should be configured in the web server or reverse proxy. Returns: Dict: Recommended security headers and their values
   *
   * @tags Security, security
   * @name GetSecurityHeadersApiSecurityHeadersGet
   * @summary Get Security Headers
   * @request GET:/api/security-headers
   */
  getSecurityHeadersApiSecurityHeadersGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/security-headers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description OAuth2 compatible token login with cookie-based authentication. **Changes:** - Sets HttpOnly cookies - Returns minimal response (frontend calls /auth/who-am-i for user data) Args: response: FastAPI Response object form_data: OAuth2 password request form Returns: Dict: Status message only (no tokens, no user data)
   *
   * @tags Authentication, authentication
   * @name LoginForAccessTokenApiAuthTokenPost
   * @summary Login For Access Token
   * @request POST:/api/auth/token
   */
  loginForAccessTokenApiAuthTokenPost = (
    data: BodyLoginForAccessTokenApiAuthTokenPost,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/token`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      format: "json",
      ...params,
    });
  /**
   * @description Refresh access token using refresh token from cookie. **Changes:** - Reads refresh_token from cookie (not request body) - Updates cookies with new tokens Args: response: FastAPI Response object refresh_token: Refresh token from cookie Returns: Dict: Status message only (no tokens, no user data)
   *
   * @tags Authentication, authentication
   * @name RefreshAccessTokenApiAuthRefreshPost
   * @summary Refresh Access Token
   * @request POST:/api/auth/refresh
   */
  refreshAccessTokenApiAuthRefreshPost = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/refresh`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Logout user by clearing authentication cookies and CSRF token. **Security:** Clears all authentication-related cookies including CSRF token. Args: response: FastAPI Response object Returns: Dict: Status message
   *
   * @tags Authentication, authentication
   * @name LogoutApiAuthLogoutPost
   * @summary Logout
   * @request POST:/api/auth/logout
   */
  logoutApiAuthLogoutPost = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/auth/logout`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Initiate Entra ID (Microsoft Azure AD) login flow. Redirects user to Microsoft login page.
   *
   * @tags Authentication, authentication
   * @name EntraLoginRedirectApiAuthEntraLoginGet
   * @summary Entra Login Redirect
   * @request GET:/api/auth/entra/login
   */
  entraLoginRedirectApiAuthEntraLoginGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/auth/entra/login`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Exchange MSAL access token for backend JWT tokens. Used when frontend handles OAuth2 flow with MSAL. Sets CSRF token cookie on successful authentication.
   *
   * @tags Authentication, authentication
   * @name EntraTokenExchangeApiAuthEntraTokenExchangePost
   * @summary Entra Token Exchange
   * @request POST:/api/auth/entra/token-exchange
   */
  entraTokenExchangeApiAuthEntraTokenExchangePost = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/entra/token-exchange`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Handle Entra ID OAuth callback and authenticate user. Sets authentication cookies and CSRF token on successful authentication.
   *
   * @tags Authentication, authentication
   * @name EntraLoginCallbackApiAuthEntraCallbackGet
   * @summary Entra Login Callback
   * @request GET:/api/auth/entra/callback
   */
  entraLoginCallbackApiAuthEntraCallbackGet = (
    query?: {
      /** Code */
      code?: string;
      /** State */
      state?: string;
      /** Error */
      error?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/entra/callback`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Register a new user. Args: user_data: User registration data Returns: Dict[str, Any]: Registration status
   *
   * @tags Authentication, authentication
   * @name RegisterUserApiAuthRegisterPost
   * @summary Register User
   * @request POST:/api/auth/register
   */
  registerUserApiAuthRegisterPost = (
    data: UserRegister,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/register`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Verify a user's email address using a token. Args: verification_data: Email verification data Returns: Dict[str, Any]: Verification status
   *
   * @tags Authentication, authentication
   * @name VerifyEmailApiAuthVerifyEmailPost
   * @summary Verify Email
   * @request POST:/api/auth/verify-email
   */
  verifyEmailApiAuthVerifyEmailPost = (
    data: EmailVerification,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/verify-email`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Resend verification email. Args: email_data: Email data containing the user's email Returns: Dict[str, Any]: Status message
   *
   * @tags Authentication, authentication
   * @name ResendVerificationEmailApiAuthResendVerificationPost
   * @summary Resend Verification Email
   * @request POST:/api/auth/resend-verification
   */
  resendVerificationEmailApiAuthResendVerificationPost = (
    data: Record<string, string>,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/resend-verification`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request a password reset. Args: reset_data: Password reset request data Returns: Dict[str, Any]: Status message
   *
   * @tags Authentication, authentication
   * @name RequestPasswordResetApiAuthRequestPasswordResetPost
   * @summary Request Password Reset
   * @request POST:/api/auth/request-password-reset
   */
  requestPasswordResetApiAuthRequestPasswordResetPost = (
    data: PasswordReset,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/request-password-reset`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Reset password with token. Args: reset_data: Password reset confirmation data Returns: Dict[str, Any]: Status message
   *
   * @tags Authentication, authentication
   * @name ResetPasswordApiAuthResetPasswordPost
   * @summary Reset Password
   * @request POST:/api/auth/reset-password
   */
  resetPasswordApiAuthResetPasswordPost = (
    data: PasswordResetConfirm,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/reset-password`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all authentication provider configurations.
   *
   * @tags Auth Providers
   * @name GetAllAuthProvidersApiAuthProvidersGet
   * @summary Get All Auth Providers
   * @request GET:/api/auth-providers/
   */
  getAllAuthProvidersApiAuthProvidersGet = (params: RequestParams = {}) =>
    this.request<AuthProviderResponse[], HTTPValidationError>({
      path: `/api/auth-providers/`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Create a new authentication provider configuration.
   *
   * @tags Auth Providers
   * @name CreateAuthProviderApiAuthProvidersPost
   * @summary Create Auth Provider
   * @request POST:/api/auth-providers/
   */
  createAuthProviderApiAuthProvidersPost = (
    data: AuthProviderConfigCreate,
    params: RequestParams = {},
  ) =>
    this.request<AuthProviderResponse, HTTPValidationError>({
      path: `/api/auth-providers/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get configuration for a specific authentication provider.
   *
   * @tags Auth Providers
   * @name GetAuthProviderApiAuthProvidersProviderTypeGet
   * @summary Get Auth Provider
   * @request GET:/api/auth-providers/{provider_type}
   */
  getAuthProviderApiAuthProvidersProviderTypeGet = (
    providerType: AuthProviderType,
    params: RequestParams = {},
  ) =>
    this.request<AuthProviderResponse, HTTPValidationError>({
      path: `/api/auth-providers/${providerType}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing authentication provider configuration.
   *
   * @tags Auth Providers
   * @name UpdateAuthProviderApiAuthProvidersProviderTypePut
   * @summary Update Auth Provider
   * @request PUT:/api/auth-providers/{provider_type}
   */
  updateAuthProviderApiAuthProvidersProviderTypePut = (
    providerType: AuthProviderType,
    data: AuthProviderConfigUpdate,
    params: RequestParams = {},
  ) =>
    this.request<AuthProviderResponse, HTTPValidationError>({
      path: `/api/auth-providers/${providerType}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an authentication provider configuration.
   *
   * @tags Auth Providers
   * @name DeleteAuthProviderApiAuthProvidersProviderTypeDelete
   * @summary Delete Auth Provider
   * @request DELETE:/api/auth-providers/{provider_type}
   */
  deleteAuthProviderApiAuthProvidersProviderTypeDelete = (
    providerType: AuthProviderType,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth-providers/${providerType}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Set the primary authentication provider for the system.
   *
   * @tags Auth Providers
   * @name SetPrimaryAuthProvider
   * @summary Set Primary Auth Provider
   * @request PUT:/api/auth-providers/primary
   */
  setPrimaryAuthProvider = (
    data: SetPrimaryProviderRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth-providers/primary`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new user (moderator or admin only). Args: user: User creation data current_user: Authenticated user with moderator privileges Returns: User: Created user object
   *
   * @tags Users, users
   * @name CreateUserApiUsersPost
   * @summary Create User
   * @request POST:/api/users/
   */
  createUserApiUsersPost = (data: UserCreate, params: RequestParams = {}) =>
    this.request<User, HTTPValidationError>({
      path: `/api/users/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a paginated list of users with optional search (all authenticated users). Note: Previously required moderator privileges, now accessible to all authenticated users. Field filtering based on role: - ADMIN: Returns all user fields (id, username, email, full_name, role, active, created_at, etc.) - MODERATOR: Returns only id, username, email, full_name - STANDARD: Returns only id, username, email, full_name Args: skip: Number of users to skip (for pagination) limit: Maximum number of users to return search: Optional search query (searches username, email, full_name) current_user: Authenticated user Returns: Dict with 'users' array (User objects for admin, UserBasicInfo for non-admin) and 'total' count
   *
   * @tags Users, users
   * @name GetUsersApiUsersGet
   * @summary Get Users
   * @request GET:/api/users/
   */
  getUsersApiUsersGet = (
    query?: {
      /**
       * Skip
       * @default 0
       */
      skip?: number;
      /**
       * Limit
       * @default 20
       */
      limit?: number;
      /** Search */
      search?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/users/`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Search users for autocomplete (returns basic info only). Args: q: Search query (searches username, email, full_name) limit: Maximum number of results current_user: Authenticated user Returns: List of basic user info for autocomplete
   *
   * @tags Users, users
   * @name SearchUsersApiUsersSearchGet
   * @summary Search Users
   * @request GET:/api/users/search
   */
  searchUsersApiUsersSearchGet = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Limit
       * Maximum number of results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/users/search`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get all active users for sharing purposes. This endpoint is accessible to all authenticated users and returns basic user information needed for sharing documents. Args: limit: Maximum number of users current_user: Authenticated user Returns: Dictionary with results list and total count
   *
   * @tags Users, users
   * @name GetUsersForSharingApiUsersForSharingGet
   * @summary Get Users For Sharing
   * @request GET:/api/users/for-sharing
   */
  getUsersForSharingApiUsersForSharingGet = (
    query?: {
      /**
       * Limit
       * Maximum number of users
       * @min 1
       * @max 200
       * @default 100
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/users/for-sharing`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get user identity information with role-based permissions from access token. Returns user information including: - Basic identity (user_id, username, email, full_name, role) - Permissions for all features based on role hierarchy Permissions are calculated from the PermissionSet class which defines hierarchical role-based access control: - STANDARD: dashboard, chat, documents, settings, my_groups - MODERATOR: + users, groups - ADMIN: + chat_config, embedding_config, text_extraction_config, document_sources, smtp_config Args: current_user: Authenticated user (extracted from JWT token) Returns: WhoAmIResponse: User identity with complete permissions mapping
   *
   * @tags Users, users
   * @name WhoAmIApiUsersWhoAmIGet
   * @summary Who Am I
   * @request GET:/api/users/who-am-i
   */
  whoAmIApiUsersWhoAmIGet = (params: RequestParams = {}) =>
    this.request<WhoAmIResponse, HTTPValidationError>({
      path: `/api/users/who-am-i`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get a user by username (admin only). Args: username: Username to look up current_user: Authenticated user with admin privileges Returns: User: User object
   *
   * @tags Users, users
   * @name GetUserApiUsersUsernameGet
   * @summary Get User
   * @request GET:/api/users/{username}
   */
  getUserApiUsersUsernameGet = (username: string, params: RequestParams = {}) =>
    this.request<User, HTTPValidationError>({
      path: `/api/users/${username}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update a user. Args: username: Username of the user to update user_update: Updated user data current_user: Authenticated user Returns: User: Updated user object
   *
   * @tags Users, users
   * @name UpdateUserApiUsersUsernamePut
   * @summary Update User
   * @request PUT:/api/users/{username}
   */
  updateUserApiUsersUsernamePut = (
    username: string,
    data: UserUpdate,
    params: RequestParams = {},
  ) =>
    this.request<User, HTTPValidationError>({
      path: `/api/users/${username}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Soft delete a user (admin only). User enters 7-day grace period. Args: username: Username of the user to delete current_user: Authenticated user with admin privileges Returns: Dict[str, Any]: Status message
   *
   * @tags Users, users
   * @name DeleteUserApiUsersUsernameDelete
   * @summary Delete User
   * @request DELETE:/api/users/{username}
   */
  deleteUserApiUsersUsernameDelete = (
    username: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/users/${username}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Change own password with current password verification. This endpoint requires the user to provide their current password for security. This prevents password changes if an attacker gains temporary access to an authenticated session. Args: password_data: Current and new password current_user: Authenticated user Returns: Success message Raises: HTTPException 401: If current password is incorrect HTTPException 400: If new password doesn't meet requirements
   *
   * @tags Users, users
   * @name ChangeOwnPasswordApiUsersMeChangePasswordPost
   * @summary Change Own Password
   * @request POST:/api/users/me/change-password
   */
  changeOwnPasswordApiUsersMeChangePasswordPost = (
    data: PasswordChangeRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/users/me/change-password`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request deletion of own account. User enters 7-day grace period. Args: current_user: Authenticated user Returns: Dict[str, Any]: Status message
   *
   * @tags Users, users
   * @name RequestOwnDeletionApiUsersMeRequestDeletionPost
   * @summary Request Own Deletion
   * @request POST:/api/users/me/request-deletion
   */
  requestOwnDeletionApiUsersMeRequestDeletionPost = (
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/users/me/request-deletion`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Cancel deletion request for a user. Users can cancel their own deletion. Admins can cancel any deletion. Args: username: Username of the user current_user: Authenticated user Returns: Dict[str, Any]: Status message
   *
   * @tags Users, users
   * @name CancelDeletionApiUsersUsernameCancelDeletionPost
   * @summary Cancel Deletion
   * @request POST:/api/users/{username}/cancel-deletion
   */
  cancelDeletionApiUsersUsernameCancelDeletionPost = (
    username: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/users/${username}/cancel-deletion`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Search groups for autocomplete (returns basic info only). Args: q: Search query (searches displayName, name, description) limit: Maximum number of results current_user: Authenticated user group_manager: GroupManager instance Returns: List of basic group info for autocomplete
   *
   * @tags Groups, groups
   * @name SearchGroupsApiGroupsSearchGet
   * @summary Search Groups
   * @request GET:/api/groups/search
   */
  searchGroupsApiGroupsSearchGet = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Limit
       * Maximum number of results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/search`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new group (with permission check).
   *
   * @tags Groups
   * @name CreateGroupApiGroupsPost
   * @summary Create Group
   * @request POST:/api/groups/
   */
  createGroupApiGroupsPost = (data: GroupCreate, params: RequestParams = {}) =>
    this.request<Group, HTTPValidationError>({
      path: `/api/groups/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List accessible groups with filters and pagination. Supports flexible filtering by query, type, status, visibility, and tags. Automatically initializes default groups if database is empty.
   *
   * @tags Groups
   * @name ListGroupsApiGroupsGet
   * @summary List Groups
   * @request GET:/api/groups/
   */
  listGroupsApiGroupsGet = (
    query?: {
      /**
       * Query
       * Search query
       */
      query?: string | null;
      /**
       * Type
       * Filter by group type
       */
      type?: GroupType | null;
      /**
       * Status
       * Filter by status
       */
      status?: GroupStatus | null;
      /**
       * Visibility
       * Filter by visibility
       */
      visibility?: GroupVisibility | null;
      /**
       * Member Of
       * Only groups user is member of
       */
      member_of?: boolean | null;
      /**
       * Admin Of
       * Only groups user administrates
       */
      admin_of?: boolean | null;
      /**
       * Tags
       * Comma-separated tags
       */
      tags?: string | null;
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupListResponse, HTTPValidationError>({
      path: `/api/groups/`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Debug endpoint to test basic authentication only.
   *
   * @tags Groups
   * @name DebugAuthOnlyApiGroupsDebugAuthOnlyGet
   * @summary Debug Auth Only
   * @request GET:/api/groups/debug/auth-only
   */
  debugAuthOnlyApiGroupsDebugAuthOnlyGet = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/debug/auth-only`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Debug endpoint to see current user info.
   *
   * @tags Groups
   * @name DebugCurrentUserApiGroupsDebugCurrentUserGet
   * @summary Debug Current User
   * @request GET:/api/groups/debug/current-user
   */
  debugCurrentUserApiGroupsDebugCurrentUserGet = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/debug/current-user`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get all groups where current user is a member with pagination. Supports filtering by membership status (active, pending, suspended, expired).
   *
   * @tags Groups
   * @name GetMyGroupsApiGroupsMyGroupsGet
   * @summary Get My Groups
   * @request GET:/api/groups/my-groups
   */
  getMyGroupsApiGroupsMyGroupsGet = (
    query?: {
      /**
       * Status
       * Filter by membership status
       */
      status?: MemberStatus | null;
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupListResponse, HTTPValidationError>({
      path: `/api/groups/my-groups`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get group details.
   *
   * @tags Groups
   * @name GetGroupApiGroupsGroupIdGet
   * @summary Get Group
   * @request GET:/api/groups/{group_id}
   */
  getGroupApiGroupsGroupIdGet = (groupId: string, params: RequestParams = {}) =>
    this.request<Group, HTTPValidationError>({
      path: `/api/groups/${groupId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update group details (Admins only).
   *
   * @tags Groups
   * @name UpdateGroupApiGroupsGroupIdPut
   * @summary Update Group
   * @request PUT:/api/groups/{group_id}
   */
  updateGroupApiGroupsGroupIdPut = (
    groupId: string,
    data: GroupUpdate,
    params: RequestParams = {},
  ) =>
    this.request<Group, HTTPValidationError>({
      path: `/api/groups/${groupId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete group (Owner only).
   *
   * @tags Groups
   * @name DeleteGroupApiGroupsGroupIdDelete
   * @summary Delete Group
   * @request DELETE:/api/groups/{group_id}
   */
  deleteGroupApiGroupsGroupIdDelete = (
    groupId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/${groupId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Request to join a group.
   *
   * @tags Groups
   * @name RequestToJoinGroupApiGroupsGroupIdJoinPost
   * @summary Request To Join Group
   * @request POST:/api/groups/{group_id}/join
   */
  requestToJoinGroupApiGroupsGroupIdJoinPost = (
    groupId: string,
    query?: {
      /** Reason */
      reason?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/${groupId}/join`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description List group members with enhanced user information and pagination. Returns detailed member information including username, full name, email, role, status, and permissions. Only accessible to group members and admins.
   *
   * @tags Groups
   * @name GetGroupMembersApiGroupsGroupIdMembersGet
   * @summary Get Group Members
   * @request GET:/api/groups/{group_id}/members
   */
  getGroupMembersApiGroupsGroupIdMembersGet = (
    groupId: string,
    query?: {
      /**
       * Status
       * Filter by status
       */
      status?: MemberStatus | null;
      /**
       * Role
       * Filter by role
       */
      role?: MemberRole | null;
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupMemberListResponse, HTTPValidationError>({
      path: `/api/groups/${groupId}/members`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Add member to group (Admins only).
   *
   * @tags Groups
   * @name AddGroupMemberApiGroupsGroupIdMembersPost
   * @summary Add Group Member
   * @request POST:/api/groups/{group_id}/members
   */
  addGroupMemberApiGroupsGroupIdMembersPost = (
    groupId: string,
    query: {
      /** User Id */
      user_id: string;
      /**
       * Roles within a group.
       * @default "member"
       */
      role?: MemberRole;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/${groupId}/members`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description List group members with enhanced user information (deprecated - use paginated version).
   *
   * @tags Groups
   * @name GetGroupMembersOldApiGroupsGroupIdMembersOldGet
   * @summary Get Group Members Old
   * @request GET:/api/groups/{group_id}/members_old
   */
  getGroupMembersOldApiGroupsGroupIdMembersOldGet = (
    groupId: string,
    query?: {
      /**
       * Status
       * Filter by status
       */
      status?: MemberStatus | null;
      /**
       * Role
       * Filter by role
       */
      role?: MemberRole | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>[], HTTPValidationError>({
      path: `/api/groups/${groupId}/members_old`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Remove member from group.
   *
   * @tags Groups
   * @name RemoveGroupMemberApiGroupsGroupIdMembersUserIdDelete
   * @summary Remove Group Member
   * @request DELETE:/api/groups/{group_id}/members/{user_id}
   */
  removeGroupMemberApiGroupsGroupIdMembersUserIdDelete = (
    groupId: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/${groupId}/members/${userId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Update member role and permissions.
   *
   * @tags Groups
   * @name UpdateGroupMemberApiGroupsGroupIdMembersUserIdPut
   * @summary Update Group Member
   * @request PUT:/api/groups/{group_id}/members/{user_id}
   */
  updateGroupMemberApiGroupsGroupIdMembersUserIdPut = (
    groupId: string,
    userId: string,
    data: GroupMemberUpdate,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/${groupId}/members/${userId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check if current user can share documents with this group.
   *
   * @tags Groups
   * @name CanShareDocumentApiGroupsGroupIdCanShareGet
   * @summary Can Share Document
   * @request GET:/api/groups/{group_id}/can-share
   */
  canShareDocumentApiGroupsGroupIdCanShareGet = (
    groupId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/${groupId}/can-share`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get audit log for group (Admins only).
   *
   * @tags Groups
   * @name GetGroupAuditLogApiGroupsGroupIdAuditGet
   * @summary Get Group Audit Log
   * @request GET:/api/groups/{group_id}/audit
   */
  getGroupAuditLogApiGroupsGroupIdAuditGet = (
    groupId: string,
    query?: {
      /**
       * Limit
       * @min 1
       * @max 500
       * @default 100
       */
      limit?: number;
      /**
       * Skip
       * @min 0
       * @default 0
       */
      skip?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/${groupId}/audit`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description List all groups with pagination (System Admins only). Returns all groups in the system without access restrictions. Supports larger page sizes (up to 100 items per page).
   *
   * @tags Groups
   * @name AdminListAllGroupsApiGroupsAdminAllGet
   * @summary Admin List All Groups
   * @request GET:/api/groups/admin/all
   */
  adminListAllGroupsApiGroupsAdminAllGet = (
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupListResponse, HTTPValidationError>({
      path: `/api/groups/admin/all`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get system-wide group statistics (System Admins only).
   *
   * @tags Groups
   * @name AdminGetGroupStatsApiGroupsAdminStatsGet
   * @summary Admin Get Group Stats
   * @request GET:/api/groups/admin/stats
   */
  adminGetGroupStatsApiGroupsAdminStatsGet = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/admin/stats`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Create a new group creation request. Only STANDARD users can submit group creation requests. ADMIN and MODERATOR users can create groups directly via POST /api/groups. Requires at least one approver (ADMIN or MODERATOR). Args: request_data: Group creation request data current_user: Authenticated standard user Returns: Created GroupRequest object Raises: HTTPException: 400 if validation fails, 403 if not standard user
   *
   * @tags Group Requests, group_requests
   * @name CreateGroupRequestApiGroupsRequestsPost
   * @summary Create Group Request
   * @request POST:/api/groups/requests
   */
  createGroupRequestApiGroupsRequestsPost = (
    data: GroupRequestCreate,
    params: RequestParams = {},
  ) =>
    this.request<GroupRequest, HTTPValidationError>({
      path: `/api/groups/requests`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get list of eligible approvers (ADMIN and MODERATOR users). Any authenticated user can see the list of approvers. Returns: List of approver user objects with id, username, email, role
   *
   * @tags Group Requests, group_requests
   * @name GetEligibleApproversApiGroupsRequestsEligibleApproversGet
   * @summary Get Eligible Approvers
   * @request GET:/api/groups/requests/eligible-approvers
   */
  getEligibleApproversApiGroupsRequestsEligibleApproversGet = (
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/requests/eligible-approvers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get current user's own group creation requests with pagination (Requirement 9). Args: status_filter: Optional status filter (pending, approved, rejected, cancelled) page: Page number (1-indexed, default: 1) page_size: Items per page (default: 20, max: 100) current_user: Authenticated user Returns: Paginated list of user's GroupRequest objects
   *
   * @tags Group Requests, group_requests
   * @name GetMyRequestsApiGroupsRequestsMyRequestsGet
   * @summary Get My Requests
   * @request GET:/api/groups/requests/my-requests
   */
  getMyRequestsApiGroupsRequestsMyRequestsGet = (
    query?: {
      /** Status Filter */
      status_filter?: string | null;
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupRequestListResponse, HTTPValidationError>({
      path: `/api/groups/requests/my-requests`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get pending group creation requests for Admin/Moderator dashboard (Requirement 9). Only ADMIN and MODERATOR users can access this endpoint. Returns requests assigned to current approver, ordered by requested_at (oldest first for FIFO). Args: page: Page number (1-indexed, default: 1) page_size: Items per page (default: 20, max: 100) current_user: Authenticated approver user Returns: Paginated list of pending GroupRequest objects with summary statistics
   *
   * @tags Group Requests, group_requests
   * @name GetPendingRequestsApiGroupsRequestsPendingGet
   * @summary Get Pending Requests
   * @request GET:/api/groups/requests/pending
   */
  getPendingRequestsApiGroupsRequestsPendingGet = (
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupRequestListResponse, HTTPValidationError>({
      path: `/api/groups/requests/pending`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get details of a specific group creation request. Users can view: - Their own requests - Requests where they are an approver (if ADMIN/MODERATOR) Args: request_id: Request ID current_user: Authenticated user Returns: GroupRequest object Raises: HTTPException: 404 if not found, 403 if not authorized
   *
   * @tags Group Requests, group_requests
   * @name GetRequestDetailsApiGroupsRequestsRequestIdGet
   * @summary Get Request Details
   * @request GET:/api/groups/requests/{request_id}
   */
  getRequestDetailsApiGroupsRequestsRequestIdGet = (
    requestId: string,
    params: RequestParams = {},
  ) =>
    this.request<GroupRequest, HTTPValidationError>({
      path: `/api/groups/requests/${requestId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Cancel a pending group creation request. Users can only cancel their own pending requests. Args: request_id: Request ID current_user: Authenticated user Returns: Success message Raises: HTTPException: 400 if not pending, 403 if not own request, 404 if not found
   *
   * @tags Group Requests, group_requests
   * @name CancelGroupRequestApiGroupsRequestsRequestIdDelete
   * @summary Cancel Group Request
   * @request DELETE:/api/groups/requests/{request_id}
   */
  cancelGroupRequestApiGroupsRequestsRequestIdDelete = (
    requestId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/requests/${requestId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Approve a group creation request. Creates the group automatically with: - Requester as group OWNER and first group admin - initial_admin_id (from request) as second group admin - Both admins get ADMIN group membership role IMPORTANT: - Approvers must have system ADMIN or MODERATOR role (to approve requests) - Group admins can be ANY user (group-level role, not system role) - Approver must be in the request's approver list Args: request_id: Request ID approval: Approval data with optional admin notes current_user: Authenticated approver user Returns: Dict with group and request information Raises: HTTPException: 400 if already processed, 403 if not authorized, 404 if not found
   *
   * @tags Group Requests, group_requests
   * @name ApproveGroupRequestApiGroupsRequestsRequestIdApprovePost
   * @summary Approve Group Request
   * @request POST:/api/groups/requests/{request_id}/approve
   */
  approveGroupRequestApiGroupsRequestsRequestIdApprovePost = (
    requestId: string,
    data: GroupRequestApproval,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/requests/${requestId}/approve`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Reject a group creation request. Only ADMIN and MODERATOR users can reject requests. Approver must be in the request's approver list. Rejection reason is required. Args: request_id: Request ID rejection: Rejection data with rejection_reason and optional admin_notes current_user: Authenticated approver user Returns: Success message Raises: HTTPException: 400 if validation fails or already processed, 403 if not authorized, 404 if not found
   *
   * @tags Group Requests, group_requests
   * @name RejectGroupRequestApiGroupsRequestsRequestIdRejectPost
   * @summary Reject Group Request
   * @request POST:/api/groups/requests/{request_id}/reject
   */
  rejectGroupRequestApiGroupsRequestsRequestIdRejectPost = (
    requestId: string,
    data: GroupRequestApproval,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/requests/${requestId}/reject`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Mark request as being viewed (UI hint only, not enforced). This provides a user experience hint showing other admins that someone is currently viewing the request. However, the actual approval/rejection uses optimistic locking, so this viewing status doesn't prevent concurrent processing. Args: request_id: Request ID current_user: Authenticated user Returns: Success status and message (includes current viewer username if someone else viewing) Raises: HTTPException: 400 if invalid request ID
   *
   * @tags Group Requests, group_requests
   * @name MarkRequestViewingApiGroupsRequestsRequestIdMarkViewingPost
   * @summary Mark Request Viewing
   * @request POST:/api/groups/requests/{request_id}/mark-viewing
   */
  markRequestViewingApiGroupsRequestsRequestIdMarkViewingPost = (
    requestId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/requests/${requestId}/mark-viewing`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Clear viewing status on a request. Called when user closes the request detail modal or navigates away. Args: request_id: Request ID current_user: Authenticated user Returns: Success message Raises: HTTPException: 400 if invalid request ID
   *
   * @tags Group Requests, group_requests
   * @name ClearRequestViewingApiGroupsRequestsRequestIdClearViewingPost
   * @summary Clear Request Viewing
   * @request POST:/api/groups/requests/{request_id}/clear-viewing
   */
  clearRequestViewingApiGroupsRequestsRequestIdClearViewingPost = (
    requestId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/requests/${requestId}/clear-viewing`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get groups where owner was deleted and awaiting new owner selection (Requirement 9). Only ADMIN and MODERATOR users can access this endpoint. Returns groups with: - Group details - Temporary owner information - List of eligible Group Admins (GAs) for selection - Member count and status Args: page: Page number (1-indexed, default: 1) page_size: Items per page (default: 20, max: 100) current_user: Authenticated admin/moderator user Returns: Paginated list of groups awaiting owner selection
   *
   * @tags Group Requests, group_admin
   * @name GetGroupsAwaitingOwnerSelectionApiGroupsOwnerDeletionsGet
   * @summary Get Groups Awaiting Owner Selection
   * @request GET:/api/groups/owner-deletions
   */
  getGroupsAwaitingOwnerSelectionApiGroupsOwnerDeletionsGet = (
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/owner-deletions`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Finalize new owner selection after owner deletion (Requirement 9). Only ADMIN and MODERATOR users can finalize owner selection. The new owner must be an existing Group Admin (GA) in the group. This endpoint: - Promotes the selected GA to OWNER role - Removes the temporary owner - Clears awaiting_owner_selection flag Args: group_id: Group ID new_owner_id: User ID of the new owner (must be existing GA) current_user: Authenticated admin/moderator user Returns: Success message with new owner details Raises: HTTPException: 400 if validation fails, 403 if not authorized, 404 if not found
   *
   * @tags Group Requests, group_admin
   * @name FinalizeNewGroupOwnerApiGroupsGroupIdFinalizeOwnerPost
   * @summary Finalize New Group Owner
   * @request POST:/api/groups/{group_id}/finalize-owner
   */
  finalizeNewGroupOwnerApiGroupsGroupIdFinalizeOwnerPost = (
    groupId: string,
    query: {
      /** New Owner Id */
      new_owner_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/groups/${groupId}/finalize-owner`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Search for users and/or groups for sharing functionality. Args: q: Search query types: Which types to search (users, groups, or both) limit: Maximum total results current_user: Authenticated user group_manager: GroupManager instance Returns: Combined search results with type indicators
   *
   * @tags Search, search
   * @name SearchRecipientsApiSearchRecipientsGet
   * @summary Search Recipients
   * @request GET:/api/search/recipients
   */
  searchRecipientsApiSearchRecipientsGet = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Types
       * Comma-separated list: users, groups
       * @default "users,groups"
       */
      types?: string;
      /**
       * Limit
       * Maximum total results
       * @min 1
       * @max 100
       * @default 20
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/search/recipients`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Search users only (convenience endpoint).
   *
   * @tags Search, search
   * @name SearchUsersOnlyApiSearchUsersGet
   * @summary Search Users Only
   * @request GET:/api/search/users
   */
  searchUsersOnlyApiSearchUsersGet = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Limit
       * Maximum number of results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/search/users`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Search groups only (convenience endpoint).
   *
   * @tags Search, search
   * @name SearchGroupsOnlyApiSearchGroupsGet
   * @summary Search Groups Only
   * @request GET:/api/search/groups
   */
  searchGroupsOnlyApiSearchGroupsGet = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Limit
       * Maximum number of results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/search/groups`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get public organization information (name, branding, etc.). No authentication required.
   *
   * @tags System
   * @name GetPublicOrganizationInfoApiSystemPublicInfoGet
   * @summary Get Public Organization Info
   * @request GET:/api/system/public/info
   */
  getPublicOrganizationInfoApiSystemPublicInfoGet = (
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/api/system/public/info`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get the complete system organization details. Requires authentication.
   *
   * @tags System
   * @name GetSystemOrganizationApiSystemGet
   * @summary Get System Organization
   * @request GET:/api/system/
   */
  getSystemOrganizationApiSystemGet = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/system/`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update the system organization. Admin only.
   *
   * @tags System
   * @name UpdateSystemOrganizationApiSystemPut
   * @summary Update System Organization
   * @request PUT:/api/system/
   */
  updateSystemOrganizationApiSystemPut = (
    data: OrganizationUpdate,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/system/`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get organization settings.
   *
   * @tags System
   * @name GetOrganizationSettingsApiSystemSettingsGet
   * @summary Get Organization Settings
   * @request GET:/api/system/settings
   */
  getOrganizationSettingsApiSystemSettingsGet = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/system/settings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update organization settings. Admin only.
   *
   * @tags System
   * @name UpdateOrganizationSettingsApiSystemSettingsPut
   * @summary Update Organization Settings
   * @request PUT:/api/system/settings
   */
  updateOrganizationSettingsApiSystemSettingsPut = (
    data: SettingsUpdate,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/system/settings`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update branding settings specifically. Admin only.
   *
   * @tags System
   * @name UpdateBrandingSettingsApiSystemSettingsBrandingPut
   * @summary Update Branding Settings
   * @request PUT:/api/system/settings/branding
   */
  updateBrandingSettingsApiSystemSettingsBrandingPut = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/system/settings/branding`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update feature flags. Admin only.
   *
   * @tags System
   * @name UpdateFeatureSettingsApiSystemSettingsFeaturesPut
   * @summary Update Feature Settings
   * @request PUT:/api/system/settings/features
   */
  updateFeatureSettingsApiSystemSettingsFeaturesPut = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/system/settings/features`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update security settings. Admin only.
   *
   * @tags System
   * @name UpdateSecuritySettingsApiSystemSettingsSecurityPut
   * @summary Update Security Settings
   * @request PUT:/api/system/settings/security
   */
  updateSecuritySettingsApiSystemSettingsSecurityPut = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/system/settings/security`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Redirect to document view endpoint. Args: document_id: ID of the document Returns: RedirectResponse: Redirect to the appropriate endpoint
   *
   * @tags Documents, documents
   * @name ViewDocumentApiDocumentsDocumentViewDocumentIdGet
   * @summary View Document
   * @request GET:/api/documents/document/view/{document_id}
   */
  viewDocumentApiDocumentsDocumentViewDocumentIdGet = (
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/documents/document/view/${documentId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Redirect to document download endpoint. Args: document_id: ID of the document Returns: RedirectResponse: Redirect to the appropriate endpoint
   *
   * @tags Documents, documents
   * @name DownloadDocumentApiDocumentsDocumentDownloadDocumentIdGet
   * @summary Download Document
   * @request GET:/api/documents/document/download/{document_id}
   */
  downloadDocumentApiDocumentsDocumentDownloadDocumentIdGet = (
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/documents/document/download/${documentId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get a paginated list of documents with filtering, sorting, and total count. Args: skip: Number of documents to skip (for pagination) limit: Maximum number of documents to return category: Optional category filter source_type: Optional source type filter (sap, custom, faq) visibility: Optional visibility filter (public, private, organization, group) owner_id: Optional owner ID filter sort_by: Optional sort order (newest, oldest, recently_updated, title_asc, title_desc) created_at_gte: Optional created date range start (ISO 8601 format) created_at_lte: Optional created date range end (ISO 8601 format) updated_at_gte: Optional updated date range start (ISO 8601 format) updated_at_lte: Optional updated date range end (ISO 8601 format) shared_with_group: Optional group ID filter (documents shared with specific group) shared_with_user: Optional user ID filter (documents shared with specific user) exclude_owned: Optional flag to exclude documents owned by current user (for "Shared with Me") current_user: Authenticated user Returns: DocumentListResponse: Paginated list of documents with total count
   *
   * @tags Documents, documents
   * @name GetDocumentsApiDocumentsGet
   * @summary Get Documents
   * @request GET:/api/documents/
   */
  getDocumentsApiDocumentsGet = (
    query?: {
      /**
       * Skip
       * @default 0
       */
      skip?: number;
      /**
       * Limit
       * @default 20
       */
      limit?: number;
      /** Category */
      category?: string | null;
      /** Source Type */
      source_type?: string | null;
      /** Visibility */
      visibility?: string | null;
      /** Owner Id */
      owner_id?: string | null;
      /** Sort By */
      sort_by?: DocumentSortBy | null;
      /** Created At Gte */
      created_at_gte?: string | null;
      /** Created At Lte */
      created_at_lte?: string | null;
      /** Updated At Gte */
      updated_at_gte?: string | null;
      /** Updated At Lte */
      updated_at_lte?: string | null;
      /** Shared With Group */
      shared_with_group?: string | null;
      /** Shared With User */
      shared_with_user?: string | null;
      /**
       * Exclude Owned
       * @default false
       */
      exclude_owned?: boolean | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<DocumentListResponse, HTTPValidationError>({
      path: `/api/documents/`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new document from text content or URL. Args: document: Document creation data (text content or URL) current_user: Authenticated user Returns: Document: Created document object Raises: DocumentValidationError: If input validation fails (handled -> 400) DatabaseOperationError: If database operations fail (handled -> 500)
   *
   * @tags Documents, documents
   * @name CreateDocumentApiDocumentsPost
   * @summary Create Document
   * @request POST:/api/documents/
   */
  createDocumentApiDocumentsPost = (
    data: DocumentCreate,
    params: RequestParams = {},
  ) =>
    this.request<Document, HTTPValidationError>({
      path: `/api/documents/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a document by ID. Args: document_id: ID of the document current_user: Authenticated user Returns: Document: Document object Raises: DocumentNotFoundError: If document doesn't exist (handled by exception handler -> 404) DocumentPermissionError: If user lacks read permission (handled -> 403)
   *
   * @tags Documents, documents
   * @name GetDocumentApiDocumentsDocumentIdGet
   * @summary Get Document
   * @request GET:/api/documents/{document_id}
   */
  getDocumentApiDocumentsDocumentIdGet = (
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Document, HTTPValidationError>({
      path: `/api/documents/${documentId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing document. Args: document_id: ID of the document to update document: Updated document data current_user: Authenticated user Returns: Document: Updated document object Raises: DocumentNotFoundError: If document doesn't exist (handled -> 404) DocumentPermissionError: If user lacks permission (handled -> 403) DatabaseOperationError: If update fails (handled -> 500)
   *
   * @tags Documents, documents
   * @name UpdateDocumentApiDocumentsDocumentIdPut
   * @summary Update Document
   * @request PUT:/api/documents/{document_id}
   */
  updateDocumentApiDocumentsDocumentIdPut = (
    documentId: string,
    data: DocumentCreate,
    params: RequestParams = {},
  ) =>
    this.request<Document, HTTPValidationError>({
      path: `/api/documents/${documentId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a document with cascade deletion across all storage layers. Users can delete their own documents, admins can delete any document. Args: document_id: ID of the document to delete reason: Optional reason for deletion (for audit trail) current_user: Authenticated user Returns: Dict[str, Any]: Status message Raises: DocumentNotFoundError: If document doesn't exist (handled -> 404) DocumentPermissionError: If user lacks permission (handled -> 403) DatabaseOperationError: If deletion fails (handled -> 500)
   *
   * @tags Documents, documents
   * @name DeleteDocumentApiDocumentsDocumentIdDelete
   * @summary Delete Document
   * @request DELETE:/api/documents/{document_id}
   */
  deleteDocumentApiDocumentsDocumentIdDelete = (
    documentId: string,
    query?: {
      /** Reason */
      reason?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/documents/${documentId}`,
      method: "DELETE",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new document by uploading a file with DSGVO-compliant ACL settings. Args: file: The uploaded file title: Optional title for the document (uses filename if not provided) category: Optional category for the document tags: Comma-separated tags visibility: Document visibility (private, organization, public) purpose: Document purpose for DSGVO compliance shared_with_users: Comma-separated user IDs to share with shared_with_groups: Comma-separated group names to share with shared_with_roles: Comma-separated roles to share with retention_days: Auto-delete after X days (optional) legal_basis: Legal basis for processing (DSGVO) current_user: Authenticated user Returns: Document: Created document object with ACL information
   *
   * @tags Documents, documents
   * @name UploadDocumentApiDocumentsUploadPost
   * @summary Upload Document
   * @request POST:/api/documents/upload
   */
  uploadDocumentApiDocumentsUploadPost = (
    data: BodyUploadDocumentApiDocumentsUploadPost,
    params: RequestParams = {},
  ) =>
    this.request<Document, HTTPValidationError>({
      path: `/api/documents/upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing document by uploading a new file. This will replace the document content and regenerate embeddings. Args: document_id: ID of the document to update file: New file to upload title: Optional new title visibility: Optional new visibility setting purpose: Optional new purpose tags: Optional comma-separated tags current_user: Authenticated user organization: Current organization request: FastAPI request object Returns: Document: Updated document object
   *
   * @tags Documents, documents
   * @name UpdateDocumentFileApiDocumentsDocumentIdFilePut
   * @summary Update Document File
   * @request PUT:/api/documents/{document_id}/file
   */
  updateDocumentFileApiDocumentsDocumentIdFilePut = (
    documentId: string,
    data: BodyUpdateDocumentFileApiDocumentsDocumentIdFilePut,
    params: RequestParams = {},
  ) =>
    this.request<Document, HTTPValidationError>({
      path: `/api/documents/${documentId}/file`,
      method: "PUT",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Get the original document file. Args: document_id: ID of the document display: If true, display inline; if false, force download current_user: Authenticated user Returns: Response: File response with the original document Raises: DocumentNotFoundError: If document doesn't exist (handled -> 404) DocumentPermissionError: If user lacks access (handled -> 403)
   *
   * @tags Documents, documents
   * @name GetOriginalDocumentApiDocumentsDocumentIdOriginalGet
   * @summary Get Original Document
   * @request GET:/api/documents/{document_id}/original
   */
  getOriginalDocumentApiDocumentsDocumentIdOriginalGet = (
    documentId: string,
    query?: {
      /**
       * Display
       * @default false
       */
      display?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/documents/${documentId}/original`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Search for documents with DSGVO-compliant ACL filtering. Uses MongoDB text search on actual documents, not vector embeddings. Args: request: Search request current_user: Authenticated user Returns: SearchResponse: Search results filtered by ACL permissions
   *
   * @tags Documents, documents
   * @name SearchDocumentsApiDocumentsSearchPost
   * @summary Search Documents
   * @request POST:/api/documents/search
   */
  searchDocumentsApiDocumentsSearchPost = (
    data: SearchRequest,
    params: RequestParams = {},
  ) =>
    this.request<SearchResponse, HTTPValidationError>({
      path: `/api/documents/search`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check user's access permissions to a specific document. Args: document_id: SHA-256 hash of the document current_user: Authenticated user Returns: AccessCheckResult: Detailed access information with anonymized sharing info
   *
   * @tags Documents, documents, acl
   * @name CheckDocumentAccessApiDocumentsDocumentIdAccessGet
   * @summary Check Document Access
   * @request GET:/api/documents/{document_id}/access
   */
  checkDocumentAccessApiDocumentsDocumentIdAccessGet = (
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<AccessCheckResult, HTTPValidationError>({
      path: `/api/documents/${documentId}/access`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Revoke user's access to a document (DSGVO right to deletion). Args: document_id: SHA-256 hash of the document current_user: Authenticated user Returns: Success message
   *
   * @tags Documents, documents, acl
   * @name RevokeDocumentAccessApiDocumentsDocumentIdAccessDelete
   * @summary Revoke Document Access
   * @request DELETE:/api/documents/{document_id}/access
   */
  revokeDocumentAccessApiDocumentsDocumentIdAccessDelete = (
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/documents/${documentId}/access`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Update ACL permissions for a document (only for document owners). Args: document_id: SHA-256 hash of the document visibility: New visibility setting purpose: New purpose setting shared_with_users: Comma-separated user IDs to share with shared_with_groups: Comma-separated group names shared_with_roles: Comma-separated roles retention_days: Auto-delete after X days current_user: Authenticated user (must be owner) Returns: Success message
   *
   * @tags Documents, documents, acl
   * @name UpdateDocumentPermissionsApiDocumentsDocumentIdPermissionsPut
   * @summary Update Document Permissions
   * @request PUT:/api/documents/{document_id}/permissions
   */
  updateDocumentPermissionsApiDocumentsDocumentIdPermissionsPut = (
    documentId: string,
    data: BodyUpdateDocumentPermissionsApiDocumentsDocumentIdPermissionsPut,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/documents/${documentId}/permissions`,
      method: "PUT",
      body: data,
      type: ContentType.UrlEncoded,
      format: "json",
      ...params,
    });
  /**
   * @description Get all document IDs that the current user has access to. Args: current_user: Authenticated user Returns: List of document hashes the user can access
   *
   * @tags Documents, documents, acl
   * @name GetMyAccessibleDocumentsApiDocumentsMyDocumentsGet
   * @summary Get My Accessible Documents
   * @request GET:/api/documents/my-documents
   */
  getMyAccessibleDocumentsApiDocumentsMyDocumentsGet = (
    params: RequestParams = {},
  ) =>
    this.request<string[], HTTPValidationError>({
      path: `/api/documents/my-documents`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Generate a chat response. Args: request: Chat request current_user: Authenticated user Returns: ChatResponse: Generated response
   *
   * @tags Chat, chat
   * @name ChatApiChatPost
   * @summary Chat
   * @request POST:/api/chat/
   */
  chatApiChatPost = (data: ChatRequest, params: RequestParams = {}) =>
    this.request<ChatResponse, HTTPValidationError>({
      path: `/api/chat/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get chat history for the current user. Args: limit: Maximum number of chat entries to return current_user: Authenticated user Returns: List[Dict[str, Any]]: Chat history entries
   *
   * @tags Chat, chat
   * @name GetChatHistoryApiChatHistoryGet
   * @summary Get Chat History
   * @request GET:/api/chat/history
   */
  getChatHistoryApiChatHistoryGet = (
    query?: {
      /**
       * Limit
       * @default 20
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ChatHistoryEntryOutput[], HTTPValidationError>({
      path: `/api/chat/history`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Delete all chat history for the current user. Args: current_user: Authenticated user Returns: Dict[str, Any]: Status message
   *
   * @tags Chat, chat
   * @name DeleteChatHistoryApiChatHistoryDelete
   * @summary Delete Chat History
   * @request DELETE:/api/chat/history
   */
  deleteChatHistoryApiChatHistoryDelete = (params: RequestParams = {}) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/chat/history`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Get all conversations for the current user with pagination. Returns a paginated list of conversations sorted by last update time. Only active (non-archived) conversations are returned. Args: pagination: Pagination parameters (page, page_size) current_user: Authenticated user Returns: PaginatedResponse[ConversationSummary]: Paginated list of user's conversations
   *
   * @tags Conversations, conversations
   * @name GetConversationsApiConversationsGet
   * @summary Get Conversations
   * @request GET:/api/conversations/
   */
  getConversationsApiConversationsGet = (
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedResponseConversationSummary, HTTPValidationError>({
      path: `/api/conversations/`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new conversation. Args: request: Conversation creation request current_user: Authenticated user Returns: ConversationSummary: Created conversation details
   *
   * @tags Conversations, conversations
   * @name CreateConversationApiConversationsPost
   * @summary Create Conversation
   * @request POST:/api/conversations/
   */
  createConversationApiConversationsPost = (
    data: CreateConversationRequest,
    params: RequestParams = {},
  ) =>
    this.request<ConversationSummary, HTTPValidationError>({
      path: `/api/conversations/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get conversation details including messages. Args: conversation_id: ID of the conversation current_user: Authenticated user Returns: ConversationDetails: Full conversation with messages
   *
   * @tags Conversations, conversations
   * @name GetConversationApiConversationsConversationIdGet
   * @summary Get Conversation
   * @request GET:/api/conversations/{conversation_id}
   */
  getConversationApiConversationsConversationIdGet = (
    conversationId: string,
    params: RequestParams = {},
  ) =>
    this.request<ConversationDetails, HTTPValidationError>({
      path: `/api/conversations/${conversationId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update conversation details. Args: conversation_id: ID of the conversation request: Update request current_user: Authenticated user Returns: ConversationSummary: Updated conversation details
   *
   * @tags Conversations, conversations
   * @name UpdateConversationApiConversationsConversationIdPut
   * @summary Update Conversation
   * @request PUT:/api/conversations/{conversation_id}
   */
  updateConversationApiConversationsConversationIdPut = (
    conversationId: string,
    data: UpdateConversationRequest,
    params: RequestParams = {},
  ) =>
    this.request<ConversationSummary, HTTPValidationError>({
      path: `/api/conversations/${conversationId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a conversation and all its messages. Args: conversation_id: ID of the conversation current_user: Authenticated user Returns: StatusResponse: Operation status
   *
   * @tags Conversations, conversations
   * @name DeleteConversationApiConversationsConversationIdDelete
   * @summary Delete Conversation
   * @request DELETE:/api/conversations/{conversation_id}
   */
  deleteConversationApiConversationsConversationIdDelete = (
    conversationId: string,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/conversations/${conversationId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Get messages for a conversation with pagination. Returns messages in chronological order (oldest first) by message_index. Only accessible to the conversation owner. Args: conversation_id: ID of the conversation pagination: Pagination parameters (page, page_size) current_user: Authenticated user Returns: PaginatedResponse[MessageResponse]: Paginated conversation messages with sources
   *
   * @tags Conversations, conversations
   * @name GetConversationMessagesApiConversationsConversationIdMessagesGet
   * @summary Get Conversation Messages
   * @request GET:/api/conversations/{conversation_id}/messages
   */
  getConversationMessagesApiConversationsConversationIdMessagesGet = (
    conversationId: string,
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<PaginatedResponseMessageResponse, HTTPValidationError>({
      path: `/api/conversations/${conversationId}/messages`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Clear all messages from a conversation. Args: conversation_id: ID of the conversation current_user: Authenticated user Returns: StatusResponse: Operation status
   *
   * @tags Conversations, conversations
   * @name ClearConversationMessagesApiConversationsConversationIdMessagesDelete
   * @summary Clear Conversation Messages
   * @request DELETE:/api/conversations/{conversation_id}/messages
   */
  clearConversationMessagesApiConversationsConversationIdMessagesDelete = (
    conversationId: string,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/conversations/${conversationId}/messages`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Search conversations by title or content. Args: q: Search query limit: Maximum results to return current_user: Authenticated user Returns: List[ConversationSummary]: Matching conversations
   *
   * @tags Conversations, conversations
   * @name SearchConversationsApiConversationsSearchGet
   * @summary Search Conversations
   * @request GET:/api/conversations/search/
   */
  searchConversationsApiConversationsSearchGet = (
    query: {
      /**
       * Q
       * Search query
       */
      q: string;
      /**
       * Limit
       * Maximum results to return
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ConversationSummary[], HTTPValidationError>({
      path: `/api/conversations/search/`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Send a chat message within a specific conversation. Supports both streaming and non-streaming responses based on request.stream parameter. Args: conversation_id: ID of the conversation request: Chat request with messages and optional stream parameter auth_context: Authentication context with user and organization Returns: ChatResponse or StreamingResponse: Generated response
   *
   * @tags Conversation Chat, conversation-chat
   * @name ChatInConversationApiConversationsConversationIdChatPost
   * @summary Chat In Conversation
   * @request POST:/api/conversations/{conversation_id}/chat
   */
  chatInConversationApiConversationsConversationIdChatPost = (
    conversationId: string,
    data: ChatRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/conversations/${conversationId}/chat`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate a title for a conversation based on its first message. Args: conversation_id: ID of the conversation auth_context: Authentication context with user and organization Returns: dict: Generated title
   *
   * @tags Conversation Chat, conversation-chat
   * @name GenerateConversationTitleApiConversationsConversationIdGenerateTitleGet
   * @summary Generate Conversation Title
   * @request GET:/api/conversations/{conversation_id}/generate-title
   */
  generateConversationTitleApiConversationsConversationIdGenerateTitleGet = (
    conversationId: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/conversations/${conversationId}/generate-title`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Create a new admin-level provider configuration for single-tenant system.
   *
   * @tags Document Sources
   * @name CreateProviderConfigApiDocumentSourcesAdminProviderConfigsPost
   * @summary Create Provider Config
   * @request POST:/api/document-sources/admin/provider-configs
   */
  createProviderConfigApiDocumentSourcesAdminProviderConfigsPost = (
    data: DocumentSourceProviderConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceProviderConfigResponse, HTTPValidationError>({
      path: `/api/document-sources/admin/provider-configs`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all admin-level provider configurations for single-tenant system.
   *
   * @tags Document Sources
   * @name GetProviderConfigsApiDocumentSourcesAdminProviderConfigsGet
   * @summary Get Provider Configs
   * @request GET:/api/document-sources/admin/provider-configs
   */
  getProviderConfigsApiDocumentSourcesAdminProviderConfigsGet = (
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceProviderConfigResponse[], HTTPValidationError>({
      path: `/api/document-sources/admin/provider-configs`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get a specific admin-level provider configuration.
   *
   * @tags Document Sources
   * @name GetProviderConfigApiDocumentSourcesAdminProviderConfigsConfigIdGet
   * @summary Get Provider Config
   * @request GET:/api/document-sources/admin/provider-configs/{config_id}
   */
  getProviderConfigApiDocumentSourcesAdminProviderConfigsConfigIdGet = (
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceProviderConfigResponse, HTTPValidationError>({
      path: `/api/document-sources/admin/provider-configs/${configId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update an admin-level provider configuration.
   *
   * @tags Document Sources
   * @name UpdateProviderConfigApiDocumentSourcesAdminProviderConfigsConfigIdPut
   * @summary Update Provider Config
   * @request PUT:/api/document-sources/admin/provider-configs/{config_id}
   */
  updateProviderConfigApiDocumentSourcesAdminProviderConfigsConfigIdPut = (
    configId: string,
    data: DocumentSourceProviderConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceProviderConfigResponse, HTTPValidationError>({
      path: `/api/document-sources/admin/provider-configs/${configId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an admin-level provider configuration.
   *
   * @tags Document Sources
   * @name DeleteProviderConfigApiDocumentSourcesAdminProviderConfigsConfigIdDelete
   * @summary Delete Provider Config
   * @request DELETE:/api/document-sources/admin/provider-configs/{config_id}
   */
  deleteProviderConfigApiDocumentSourcesAdminProviderConfigsConfigIdDelete = (
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/document-sources/admin/provider-configs/${configId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Create a new user connection to a document source.
   *
   * @tags Document Sources
   * @name CreateUserConnectionApiDocumentSourcesUserConnectionsPost
   * @summary Create User Connection
   * @request POST:/api/document-sources/user/connections
   */
  createUserConnectionApiDocumentSourcesUserConnectionsPost = (
    data: DocumentSourceUserConnectionRequest,
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceUserConnectionResponse, HTTPValidationError>({
      path: `/api/document-sources/user/connections`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all user connections for the current user.
   *
   * @tags Document Sources
   * @name GetUserConnectionsApiDocumentSourcesUserConnectionsGet
   * @summary Get User Connections
   * @request GET:/api/document-sources/user/connections
   */
  getUserConnectionsApiDocumentSourcesUserConnectionsGet = (
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceUserConnectionResponse[], HTTPValidationError>({
      path: `/api/document-sources/user/connections`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get a specific user connection.
   *
   * @tags Document Sources
   * @name GetUserConnectionApiDocumentSourcesUserConnectionsConnectionIdGet
   * @summary Get User Connection
   * @request GET:/api/document-sources/user/connections/{connection_id}
   */
  getUserConnectionApiDocumentSourcesUserConnectionsConnectionIdGet = (
    connectionId: string,
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceUserConnectionResponse, HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update a user connection.
   *
   * @tags Document Sources
   * @name UpdateUserConnectionApiDocumentSourcesUserConnectionsConnectionIdPut
   * @summary Update User Connection
   * @request PUT:/api/document-sources/user/connections/{connection_id}
   */
  updateUserConnectionApiDocumentSourcesUserConnectionsConnectionIdPut = (
    connectionId: string,
    data: DocumentSourceUserConnectionRequest,
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceUserConnectionResponse, HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a user connection.
   *
   * @tags Document Sources
   * @name DeleteUserConnectionApiDocumentSourcesUserConnectionsConnectionIdDelete
   * @summary Delete User Connection
   * @request DELETE:/api/document-sources/user/connections/{connection_id}
   */
  deleteUserConnectionApiDocumentSourcesUserConnectionsConnectionIdDelete = (
    connectionId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Start a sync operation for a user connection.
   *
   * @tags Document Sources
   * @name SyncUserConnectionApiDocumentSourcesUserConnectionsConnectionIdSyncPost
   * @summary Sync User Connection
   * @request POST:/api/document-sources/user/connections/{connection_id}/sync
   */
  syncUserConnectionApiDocumentSourcesUserConnectionsConnectionIdSyncPost = (
    connectionId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}/sync`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get sync status for a user connection.
   *
   * @tags Document Sources
   * @name GetSyncStatusApiDocumentSourcesUserConnectionsConnectionIdSyncStatusGet
   * @summary Get Sync Status
   * @request GET:/api/document-sources/user/connections/{connection_id}/sync-status
   */
  getSyncStatusApiDocumentSourcesUserConnectionsConnectionIdSyncStatusGet = (
    connectionId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}/sync-status`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get statistics for a user connection.
   *
   * @tags Document Sources
   * @name GetConnectionStatsApiDocumentSourcesUserConnectionsConnectionIdStatsGet
   * @summary Get Connection Stats
   * @request GET:/api/document-sources/user/connections/{connection_id}/stats
   */
  getConnectionStatsApiDocumentSourcesUserConnectionsConnectionIdStatsGet = (
    connectionId: string,
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceSyncStatsResponse, HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}/stats`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get all user connections (admin only).
   *
   * @tags Document Sources
   * @name AdminGetAllConnectionsApiDocumentSourcesAdminAllConnectionsGet
   * @summary Admin Get All Connections
   * @request GET:/api/document-sources/admin/all-connections
   */
  adminGetAllConnectionsApiDocumentSourcesAdminAllConnectionsGet = (
    params: RequestParams = {},
  ) =>
    this.request<DocumentSourceUserConnectionResponse[], HTTPValidationError>({
      path: `/api/document-sources/admin/all-connections`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Force sync a connection (admin only).
   *
   * @tags Document Sources
   * @name AdminSyncConnectionApiDocumentSourcesAdminConnectionsConnectionIdSyncPost
   * @summary Admin Sync Connection
   * @request POST:/api/document-sources/admin/connections/{connection_id}/sync
   */
  adminSyncConnectionApiDocumentSourcesAdminConnectionsConnectionIdSyncPost = (
    connectionId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/document-sources/admin/connections/${connectionId}/sync`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get system-wide document source statistics (admin only).
   *
   * @tags Document Sources
   * @name AdminGetSystemStatsApiDocumentSourcesAdminStatsGet
   * @summary Admin Get System Stats
   * @request GET:/api/document-sources/admin/stats
   */
  adminGetSystemStatsApiDocumentSourcesAdminStatsGet = (
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/document-sources/admin/stats`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get available document source providers.
   *
   * @tags Document Sources
   * @name GetAvailableProvidersApiDocumentSourcesProvidersGet
   * @summary Get Available Providers
   * @request GET:/api/document-sources/providers
   */
  getAvailableProvidersApiDocumentSourcesProvidersGet = (
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/document-sources/providers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Parse SharePoint URL to extract path and folder information.
   *
   * @tags Document Sources
   * @name ParseSharepointLinkApiDocumentSourcesUserConnectionsParseSharepointLinkPost
   * @summary Parse Sharepoint Link
   * @request POST:/api/document-sources/user/connections/parse-sharepoint-link
   */
  parseSharepointLinkApiDocumentSourcesUserConnectionsParseSharepointLinkPost =
    (data: Record<string, any>, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/api/document-sources/user/connections/parse-sharepoint-link`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      });
  /**
   * @description Browse files and folders in SharePoint connection for selection.
   *
   * @tags Document Sources
   * @name BrowseSharepointFilesApiDocumentSourcesUserConnectionsConnectionIdBrowseFilesPost
   * @summary Browse Sharepoint Files
   * @request POST:/api/document-sources/user/connections/{connection_id}/browse-files
   */
  browseSharepointFilesApiDocumentSourcesUserConnectionsConnectionIdBrowseFilesPost =
    (
      connectionId: string,
      data: Record<string, any>,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/document-sources/user/connections/${connectionId}/browse-files`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      });
  /**
   * @description Start sync with only selected files from file tree.
   *
   * @tags Document Sources
   * @name SyncSelectedFilesApiDocumentSourcesUserConnectionsConnectionIdSyncSelectedPost
   * @summary Sync Selected Files
   * @request POST:/api/document-sources/user/connections/{connection_id}/sync-selected
   */
  syncSelectedFilesApiDocumentSourcesUserConnectionsConnectionIdSyncSelectedPost =
    (
      connectionId: string,
      data: Record<string, any>,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/document-sources/user/connections/${connectionId}/sync-selected`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      });
  /**
   * @description Get recursive file listing for a SharePoint connection.
   *
   * @tags Document Sources
   * @name RecursiveFileScanApiDocumentSourcesUserConnectionsConnectionIdRecursiveScanGet
   * @summary Recursive File Scan
   * @request GET:/api/document-sources/user/connections/{connection_id}/recursive-scan
   */
  recursiveFileScanApiDocumentSourcesUserConnectionsConnectionIdRecursiveScanGet =
    (
      connectionId: string,
      query?: {
        /**
         * Folder Path
         * @default "/"
         */
        folder_path?: string;
        /**
         * Max Depth
         * @default 5
         */
        max_depth?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/document-sources/user/connections/${connectionId}/recursive-scan`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      });
  /**
   * @description Erstellt einen neuen FAQ als Document.
   *
   * @tags FAQs, FAQ Documents
   * @name CreateFaqApiFaqDocumentsPost
   * @summary FAQ erstellen
   * @request POST:/api/faq-documents
   */
  createFaqApiFaqDocumentsPost = (
    data: FAQDocumentCreate,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List FAQs with filtering, pagination, and sorting.
   *
   * @tags FAQs, FAQ Documents
   * @name ListFaqsApiFaqDocumentsGet
   * @summary FAQs auflisten
   * @request GET:/api/faq-documents
   */
  listFaqsApiFaqDocumentsGet = (
    query?: {
      /**
       * Status Filter
       * Filter by status
       */
      status_filter?: FAQStatus | null;
      /**
       * Approval Status
       * Filter by approval status
       */
      approval_status?: string | null;
      /**
       * Category
       * Filter by category
       */
      category?: string | null;
      /**
       * Sort By
       * Sort order (newest, oldest, best_rated)
       */
      sort_by?: FAQSortBy | null;
      /**
       * Page
       * Page number
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<FAQListResponse, HTTPValidationError>({
      path: `/api/faq-documents`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get FAQ statistics.
   *
   * @tags FAQs, FAQ Documents
   * @name GetFaqStatsApiFaqDocumentsStatsGet
   * @summary FAQ Statistiken
   * @request GET:/api/faq-documents/stats
   */
  getFaqStatsApiFaqDocumentsStatsGet = (params: RequestParams = {}) =>
    this.request<FAQStatsResponse, HTTPValidationError>({
      path: `/api/faq-documents/stats`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Search FAQs using vector search.
   *
   * @tags FAQs, FAQ Documents
   * @name SearchFaqsApiFaqDocumentsSearchGet
   * @summary FAQs durchsuchen
   * @request GET:/api/faq-documents/search
   */
  searchFaqsApiFaqDocumentsSearchGet = (
    query: {
      /**
       * Query
       * Search query
       */
      query: string;
      /**
       * Limit
       * Max results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<FAQSearchResponse, HTTPValidationError>({
      path: `/api/faq-documents/search`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get FAQ details.
   *
   * @tags FAQs, FAQ Documents
   * @name GetFaqApiFaqDocumentsFaqIdGet
   * @summary FAQ Details
   * @request GET:/api/faq-documents/{faq_id}
   */
  getFaqApiFaqDocumentsFaqIdGet = (faqId: string, params: RequestParams = {}) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update FAQ content.
   *
   * @tags FAQs, FAQ Documents
   * @name UpdateFaqApiFaqDocumentsFaqIdPut
   * @summary FAQ aktualisieren
   * @request PUT:/api/faq-documents/{faq_id}
   */
  updateFaqApiFaqDocumentsFaqIdPut = (
    faqId: string,
    data: FAQDocumentUpdate,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete FAQ (admin/moderator only).
   *
   * @tags FAQs, FAQ Documents
   * @name DeleteFaqApiFaqDocumentsFaqIdDelete
   * @summary FAQ löschen
   * @request DELETE:/api/faq-documents/{faq_id}
   */
  deleteFaqApiFaqDocumentsFaqIdDelete = (
    faqId: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Update FAQ status (submit, approve, publish, reject, archive).
   *
   * @tags FAQs, FAQ Documents
   * @name UpdateFaqStatusApiFaqDocumentsFaqIdStatusPost
   * @summary FAQ Status ändern
   * @request POST:/api/faq-documents/{faq_id}/status
   */
  updateFaqStatusApiFaqDocumentsFaqIdStatusPost = (
    faqId: string,
    data: FAQStatusUpdate,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/status`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit FAQ for approval by moderators. Only the owner can submit their own FAQ.
   *
   * @tags FAQs, FAQ Documents
   * @name SubmitFaqForApprovalApiFaqDocumentsFaqIdSubmitPost
   * @summary FAQ zur Freigabe einreichen
   * @request POST:/api/faq-documents/{faq_id}/submit
   */
  submitFaqForApprovalApiFaqDocumentsFaqIdSubmitPost = (
    faqId: string,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/submit`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Approve FAQ. Requires appropriate moderation privileges based on FAQ visibility.
   *
   * @tags FAQs, FAQ Documents
   * @name ApproveFaqApiFaqDocumentsFaqIdApprovePost
   * @summary FAQ freigeben
   * @request POST:/api/faq-documents/{faq_id}/approve
   */
  approveFaqApiFaqDocumentsFaqIdApprovePost = (
    faqId: string,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/approve`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Reject FAQ with reason. Requires appropriate moderation privileges. Args: faq_id: FAQ document ID to reject rejection_reason: Reason for rejection (10-500 characters, sanitized to prevent XSS) current_user: Authenticated user with moderator/admin privileges faq_service: FAQ service dependency Returns: Rejected FAQ document Raises: HTTPException: 400 if rejection_reason invalid, 403 if not moderator, 404 if FAQ not found
   *
   * @tags FAQs, FAQ Documents
   * @name RejectFaqApiFaqDocumentsFaqIdRejectPost
   * @summary FAQ ablehnen
   * @request POST:/api/faq-documents/{faq_id}/reject
   */
  rejectFaqApiFaqDocumentsFaqIdRejectPost = (
    faqId: string,
    query: {
      /**
       * Rejection Reason
       * Rejection reason (10-500 characters required)
       * @minLength 10
       * @maxLength 500
       */
      rejection_reason: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/reject`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Publish FAQ (moderator only).
   *
   * @tags FAQs, FAQ Documents
   * @name PublishFaqApiFaqDocumentsFaqIdPublishPost
   * @summary FAQ veröffentlichen
   * @request POST:/api/faq-documents/{faq_id}/publish
   */
  publishFaqApiFaqDocumentsFaqIdPublishPost = (
    faqId: string,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/publish`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Rate an FAQ as helpful or not helpful.
   *
   * @tags FAQs, FAQ Documents
   * @name RateFaqApiFaqDocumentsFaqIdRatePost
   * @summary FAQ bewerten
   * @request POST:/api/faq-documents/{faq_id}/rate
   */
  rateFaqApiFaqDocumentsFaqIdRatePost = (
    faqId: string,
    query: {
      /**
       * Helpful
       * True if helpful, False if not helpful
       */
      helpful: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/rate`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a user's vote from an FAQ.
   *
   * @tags FAQs, FAQ Documents
   * @name UnrateFaqApiFaqDocumentsFaqIdRateDelete
   * @summary FAQ-Bewertung entfernen
   * @request DELETE:/api/faq-documents/{faq_id}/rate
   */
  unrateFaqApiFaqDocumentsFaqIdRateDelete = (
    faqId: string,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/rate`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Get system statistics. Single-tenant system.
   *
   * @tags Admin, admin
   * @name GetSystemStatsApiAdminStatsSystemGet
   * @summary Get System Statistics
   * @request GET:/api/admin/stats/system
   */
  getSystemStatsApiAdminStatsSystemGet = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/admin/stats/system`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get recent system errors. Single-tenant system.
   *
   * @tags Admin, admin
   * @name GetRecentErrorsApiAdminErrorsGet
   * @summary Get Recent Errors
   * @request GET:/api/admin/errors
   */
  getRecentErrorsApiAdminErrorsGet = (
    query?: {
      /**
       * Limit
       * @default 20
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/admin/errors`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Get document processing queue status. Single-tenant system.
   *
   * @tags Admin, admin
   * @name GetProcessingQueueApiAdminQueueGet
   * @summary Get Document Processing Queue
   * @request GET:/api/admin/queue
   */
  getProcessingQueueApiAdminQueueGet = (
    query?: {
      /**
       * Limit
       * @default 20
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/admin/queue`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description System health check endpoint.
   *
   * @tags Admin, admin
   * @name HealthCheckApiAdminHealthGet
   * @summary Health Check
   * @request GET:/api/admin/health
   */
  healthCheckApiAdminHealthGet = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/admin/health`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get overall system status and statistics.
   *
   * @tags Server Admin
   * @name GetSystemStatusApiServerAdminStatusGet
   * @summary Get System Status
   * @request GET:/api/server-admin/status
   */
  getSystemStatusApiServerAdminStatusGet = (params: RequestParams = {}) =>
    this.request<SystemStatusResponse, HTTPValidationError>({
      path: `/api/server-admin/status`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Clean up all data from MongoDB, Qdrant, and S3. WARNING: This is destructive!
   *
   * @tags Server Admin
   * @name CleanupAllDataApiServerAdminCleanupAllPost
   * @summary Cleanup All Data
   * @request POST:/api/server-admin/cleanup/all
   */
  cleanupAllDataApiServerAdminCleanupAllPost = (params: RequestParams = {}) =>
    this.request<SystemCleanupResponse, HTTPValidationError>({
      path: `/api/server-admin/cleanup/all`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Fix duplicate ACL entries by removing duplicates.
   *
   * @tags Server Admin
   * @name FixDuplicateAclEntriesApiServerAdminFixDuplicateAclPost
   * @summary Fix Duplicate Acl Entries
   * @request POST:/api/server-admin/fix/duplicate-acl
   */
  fixDuplicateAclEntriesApiServerAdminFixDuplicateAclPost = (
    params: RequestParams = {},
  ) =>
    this.request<SystemCleanupResponse, HTTPValidationError>({
      path: `/api/server-admin/fix/duplicate-acl`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Recreate Qdrant collection with fresh schema.
   *
   * @tags Server Admin
   * @name RecreateQdrantCollectionApiServerAdminRecreateQdrantCollectionNamePost
   * @summary Recreate Qdrant Collection
   * @request POST:/api/server-admin/recreate-qdrant/{collection_name}
   */
  recreateQdrantCollectionApiServerAdminRecreateQdrantCollectionNamePost = (
    collectionName: string,
    params: RequestParams = {},
  ) =>
    this.request<QdrantCollectionResponse, HTTPValidationError>({
      path: `/api/server-admin/recreate-qdrant/${collectionName}`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get SMTP configuration from database or environment variables.
   *
   * @tags Server Admin
   * @name GetSmtpConfigApiServerAdminConfigSmtpGet
   * @summary Get Smtp Config
   * @request GET:/api/server-admin/config/smtp
   */
  getSmtpConfigApiServerAdminConfigSmtpGet = (params: RequestParams = {}) =>
    this.request<SMTPConfigurationResponse, HTTPValidationError>({
      path: `/api/server-admin/config/smtp`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Save SMTP configuration to database.
   *
   * @tags Server Admin
   * @name SaveSmtpConfigApiServerAdminConfigSmtpPost
   * @summary Save Smtp Config
   * @request POST:/api/server-admin/config/smtp
   */
  saveSmtpConfigApiServerAdminConfigSmtpPost = (
    data: Record<string, string | number | boolean>,
    params: RequestParams = {},
  ) =>
    this.request<SMTPConfigurationResponse, HTTPValidationError>({
      path: `/api/server-admin/config/smtp`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get comprehensive system health and performance metrics.
   *
   * @tags Performance
   * @name GetSystemHealthApiAdminPerformanceHealthGet
   * @summary Get System Health
   * @request GET:/api/admin/performance/health
   */
  getSystemHealthApiAdminPerformanceHealthGet = (params: RequestParams = {}) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/admin/performance/health`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get slow database queries above threshold.
   *
   * @tags Performance
   * @name GetSlowQueriesApiAdminPerformanceSlowQueriesGet
   * @summary Get Slow Queries
   * @request GET:/api/admin/performance/slow-queries
   */
  getSlowQueriesApiAdminPerformanceSlowQueriesGet = (
    query?: {
      /**
       * Threshold Ms
       * @default 100
       */
      threshold_ms?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/admin/performance/slow-queries`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Analyze common query patterns and performance.
   *
   * @tags Performance
   * @name AnalyzeQueryPatternsApiAdminPerformanceQueryPatternsGet
   * @summary Analyze Query Patterns
   * @request GET:/api/admin/performance/query-patterns
   */
  analyzeQueryPatternsApiAdminPerformanceQueryPatternsGet = (
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/admin/performance/query-patterns`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get database connection pool health metrics.
   *
   * @tags Performance
   * @name GetConnectionHealthApiAdminPerformanceConnectionHealthGet
   * @summary Get Connection Health
   * @request GET:/api/admin/performance/connection-health
   */
  getConnectionHealthApiAdminPerformanceConnectionHealthGet = (
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/admin/performance/connection-health`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get index usage effectiveness analysis.
   *
   * @tags Performance
   * @name GetIndexEffectivenessApiAdminPerformanceIndexEffectivenessGet
   * @summary Get Index Effectiveness
   * @request GET:/api/admin/performance/index-effectiveness
   */
  getIndexEffectivenessApiAdminPerformanceIndexEffectivenessGet = (
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/admin/performance/index-effectiveness`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get current memory usage statistics.
   *
   * @tags Performance
   * @name GetMemoryUsageApiAdminPerformanceMemoryUsageGet
   * @summary Get Memory Usage
   * @request GET:/api/admin/performance/memory-usage
   */
  getMemoryUsageApiAdminPerformanceMemoryUsageGet = (
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/admin/performance/memory-usage`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Enable MongoDB profiler for performance monitoring.
   *
   * @tags Performance
   * @name EnableDatabaseProfilerApiAdminPerformanceProfilerEnablePost
   * @summary Enable Database Profiler
   * @request POST:/api/admin/performance/profiler/enable
   */
  enableDatabaseProfilerApiAdminPerformanceProfilerEnablePost = (
    query?: {
      /**
       * Level
       * @default 2
       */
      level?: number;
      /**
       * Slow Ms
       * @default 100
       */
      slow_ms?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/performance/profiler/enable`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Disable MongoDB profiler.
   *
   * @tags Performance
   * @name DisableDatabaseProfilerApiAdminPerformanceProfilerDisablePost
   * @summary Disable Database Profiler
   * @request POST:/api/admin/performance/profiler/disable
   */
  disableDatabaseProfilerApiAdminPerformanceProfilerDisablePost = (
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/performance/profiler/disable`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get AI-generated performance optimization recommendations.
   *
   * @tags Performance
   * @name GetPerformanceRecommendationsApiAdminPerformanceRecommendationsGet
   * @summary Get Performance Recommendations
   * @request GET:/api/admin/performance/recommendations
   */
  getPerformanceRecommendationsApiAdminPerformanceRecommendationsGet = (
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/admin/performance/recommendations`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get SMTP configuration. Falls back to environment variables if no database config exists.
   *
   * @tags SMTP
   * @name GetSmtpConfigApiAdminSmtpConfigGet
   * @summary Get Smtp Config
   * @request GET:/api/admin/smtp/config
   */
  getSmtpConfigApiAdminSmtpConfigGet = (params: RequestParams = {}) =>
    this.request<SMTPConfigResponse, HTTPValidationError>({
      path: `/api/admin/smtp/config`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Save SMTP configuration.
   *
   * @tags SMTP
   * @name SaveSmtpConfigApiAdminSmtpConfigPost
   * @summary Save Smtp Config
   * @request POST:/api/admin/smtp/config
   */
  saveSmtpConfigApiAdminSmtpConfigPost = (
    data: SMTPConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/admin/smtp/config`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete SMTP configuration (revert to environment settings).
   *
   * @tags SMTP
   * @name DeleteSmtpConfigApiAdminSmtpConfigDelete
   * @summary Delete Smtp Config
   * @request DELETE:/api/admin/smtp/config
   */
  deleteSmtpConfigApiAdminSmtpConfigDelete = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/admin/smtp/config`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Debug SMTP connection step by step.
   *
   * @tags SMTP
   * @name DebugSmtpConnectionApiAdminSmtpDebugPost
   * @summary Debug Smtp Connection
   * @request POST:/api/admin/smtp/debug
   */
  debugSmtpConnectionApiAdminSmtpDebugPost = (params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/admin/smtp/debug`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Send a test email using the current SMTP configuration.
   *
   * @tags SMTP
   * @name TestSmtpConfigApiAdminSmtpTestPost
   * @summary Test Smtp Config
   * @request POST:/api/admin/smtp/test
   */
  testSmtpConfigApiAdminSmtpTestPost = (
    data: TestEmailRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/admin/smtp/test`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get available chat providers.
   *
   * @tags Chat Config
   * @name GetAvailableProvidersApiAdminChatConfigProvidersGet
   * @summary Get Available Providers
   * @request GET:/api/admin/chat-config/providers
   */
  getAvailableProvidersApiAdminChatConfigProvidersGet = (
    params: RequestParams = {},
  ) =>
    this.request<ChatProviderResponse[], HTTPValidationError>({
      path: `/api/admin/chat-config/providers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get currently active default chat configuration.
   *
   * @tags Chat Config
   * @name GetCurrentConfigApiAdminChatConfigCurrentGet
   * @summary Get Current Config
   * @request GET:/api/admin/chat-config/current
   */
  getCurrentConfigApiAdminChatConfigCurrentGet = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse, HTTPValidationError>({
      path: `/api/admin/chat-config/current`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get all chat configurations.
   *
   * @tags Chat Config
   * @name GetAllConfigsApiAdminChatConfigAllGet
   * @summary Get All Configs
   * @request GET:/api/admin/chat-config/all
   */
  getAllConfigsApiAdminChatConfigAllGet = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse[], HTTPValidationError>({
      path: `/api/admin/chat-config/all`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get all currently active chat configurations.
   *
   * @tags Chat Config
   * @name GetActiveConfigsApiAdminChatConfigActiveGet
   * @summary Get Active Configs
   * @request GET:/api/admin/chat-config/active
   */
  getActiveConfigsApiAdminChatConfigActiveGet = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse[], HTTPValidationError>({
      path: `/api/admin/chat-config/active`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Test a chat configuration without saving it.
   *
   * @tags Chat Config
   * @name TestConfigApiAdminChatConfigTestPost
   * @summary Test Config
   * @request POST:/api/admin/chat-config/test
   */
  testConfigApiAdminChatConfigTestPost = (
    data: ChatConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<ChatConfigTest, HTTPValidationError>({
      path: `/api/admin/chat-config/test`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Save and activate a chat configuration.
   *
   * @tags Chat Config
   * @name SaveConfigApiAdminChatConfigSavePost
   * @summary Save Config
   * @request POST:/api/admin/chat-config/save
   */
  saveConfigApiAdminChatConfigSavePost = (
    data: ChatConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/chat-config/save`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing chat configuration.
   *
   * @tags Chat Config
   * @name UpdateConfigApiAdminChatConfigConfigIdPut
   * @summary Update Config
   * @request PUT:/api/admin/chat-config/{config_id}
   */
  updateConfigApiAdminChatConfigConfigIdPut = (
    configId: string,
    data: ChatConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/chat-config/${configId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a chat configuration.
   *
   * @tags Chat Config
   * @name DeleteConfigApiAdminChatConfigConfigIdDelete
   * @summary Delete Config
   * @request DELETE:/api/admin/chat-config/{config_id}
   */
  deleteConfigApiAdminChatConfigConfigIdDelete = (
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/chat-config/${configId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Reset to environment variable configuration.
   *
   * @tags Chat Config
   * @name ResetToEnvApiAdminChatConfigResetToEnvPost
   * @summary Reset To Env
   * @request POST:/api/admin/chat-config/reset-to-env
   */
  resetToEnvApiAdminChatConfigResetToEnvPost = (params: RequestParams = {}) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/chat-config/reset-to-env`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get currently active default chat configuration (optimized endpoint). PERFORMANCE OPTIMIZATION: - Single DB query optimized for single-tenant system
   *
   * @tags Chat Config
   * @name GetCurrentConfigOptimizedApiAdminChatConfigCurrentOptimizedGet
   * @summary Get Current Config Optimized
   * @request GET:/api/admin/chat-config/current-optimized
   */
  getCurrentConfigOptimizedApiAdminChatConfigCurrentOptimizedGet = (
    params: RequestParams = {},
  ) =>
    this.request<ChatConfigResponse, HTTPValidationError>({
      path: `/api/admin/chat-config/current-optimized`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get available chat configurations for user selection.
   *
   * @tags Chat Config
   * @name GetAvailableConfigsApiAdminChatConfigUserAvailableGet
   * @summary Get Available Configs
   * @request GET:/api/admin/chat-config/user/available
   */
  getAvailableConfigsApiAdminChatConfigUserAvailableGet = (
    params: RequestParams = {},
  ) =>
    this.request<ChatConfigResponse[], HTTPValidationError>({
      path: `/api/admin/chat-config/user/available`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get user's currently selected chat configuration.
   *
   * @tags Chat Config
   * @name GetUserCurrentConfigApiAdminChatConfigUserCurrentGet
   * @summary Get User Current Config
   * @request GET:/api/admin/chat-config/user/current
   */
  getUserCurrentConfigApiAdminChatConfigUserCurrentGet = (
    params: RequestParams = {},
  ) =>
    this.request<ChatConfigResponse, HTTPValidationError>({
      path: `/api/admin/chat-config/user/current`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Save user's preferred chat model.
   *
   * @tags Chat Config
   * @name SaveUserPreferenceApiAdminChatConfigUserPreferencePost
   * @summary Save User Preference
   * @request POST:/api/admin/chat-config/user/preference
   */
  saveUserPreferenceApiAdminChatConfigUserPreferencePost = (
    data: UserChatPreference,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/chat-config/user/preference`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get available embedding providers with active status.
   *
   * @tags Embedding Config
   * @name GetAvailableProvidersApiAdminEmbeddingConfigProvidersGet
   * @summary Get Available Providers
   * @request GET:/api/admin/embedding-config/providers
   */
  getAvailableProvidersApiAdminEmbeddingConfigProvidersGet = (
    params: RequestParams = {},
  ) =>
    this.request<EmbeddingProviderResponse[], HTTPValidationError>({
      path: `/api/admin/embedding-config/providers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get currently active embedding configuration.
   *
   * @tags Embedding Config
   * @name GetCurrentConfigApiAdminEmbeddingConfigCurrentGet
   * @summary Get Current Config
   * @request GET:/api/admin/embedding-config/current
   */
  getCurrentConfigApiAdminEmbeddingConfigCurrentGet = (
    params: RequestParams = {},
  ) =>
    this.request<EmbeddingConfigResponse, HTTPValidationError>({
      path: `/api/admin/embedding-config/current`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get all embedding configurations.
   *
   * @tags Embedding Config
   * @name GetAllConfigsApiAdminEmbeddingConfigAllGet
   * @summary Get All Configs
   * @request GET:/api/admin/embedding-config/all
   */
  getAllConfigsApiAdminEmbeddingConfigAllGet = (params: RequestParams = {}) =>
    this.request<EmbeddingConfigResponse[], HTTPValidationError>({
      path: `/api/admin/embedding-config/all`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Test an embedding configuration without saving it.
   *
   * @tags Embedding Config
   * @name TestConfigApiAdminEmbeddingConfigTestPost
   * @summary Test Config
   * @request POST:/api/admin/embedding-config/test
   */
  testConfigApiAdminEmbeddingConfigTestPost = (
    data: EmbeddingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<EmbeddingTestResponse, HTTPValidationError>({
      path: `/api/admin/embedding-config/test`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Save and activate an embedding configuration.
   *
   * @tags Embedding Config
   * @name SaveConfigApiAdminEmbeddingConfigSavePost
   * @summary Save Config
   * @request POST:/api/admin/embedding-config/save
   */
  saveConfigApiAdminEmbeddingConfigSavePost = (
    data: EmbeddingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/embedding-config/save`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an embedding configuration.
   *
   * @tags Embedding Config
   * @name DeleteConfigApiAdminEmbeddingConfigConfigIdDelete
   * @summary Delete Config
   * @request DELETE:/api/admin/embedding-config/{config_id}
   */
  deleteConfigApiAdminEmbeddingConfigConfigIdDelete = (
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/embedding-config/${configId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Activate an existing embedding configuration.
   *
   * @tags Embedding Config
   * @name ActivateConfigApiAdminEmbeddingConfigConfigIdActivatePost
   * @summary Activate Config
   * @request POST:/api/admin/embedding-config/{config_id}/activate
   */
  activateConfigApiAdminEmbeddingConfigConfigIdActivatePost = (
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/embedding-config/${configId}/activate`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Reset to environment variable configuration.
   *
   * @tags Embedding Config
   * @name ResetToEnvApiAdminEmbeddingConfigResetToEnvPost
   * @summary Reset To Env
   * @request POST:/api/admin/embedding-config/reset-to-env
   */
  resetToEnvApiAdminEmbeddingConfigResetToEnvPost = (
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/embedding-config/reset-to-env`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get available text extraction providers.
   *
   * @tags Text Extraction
   * @name GetAvailableProvidersApiAdminTextExtractionConfigProvidersGet
   * @summary Get Available Providers
   * @request GET:/api/admin/text-extraction-config/providers
   */
  getAvailableProvidersApiAdminTextExtractionConfigProvidersGet = (
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>[], HTTPValidationError>({
      path: `/api/admin/text-extraction-config/providers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get currently active text extraction configuration.
   *
   * @tags Text Extraction
   * @name GetCurrentConfigApiAdminTextExtractionConfigCurrentGet
   * @summary Get Current Config
   * @request GET:/api/admin/text-extraction-config/current
   */
  getCurrentConfigApiAdminTextExtractionConfigCurrentGet = (
    params: RequestParams = {},
  ) =>
    this.request<TextExtractionResponse, HTTPValidationError>({
      path: `/api/admin/text-extraction-config/current`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get all text extraction configurations.
   *
   * @tags Text Extraction
   * @name GetAllConfigsApiAdminTextExtractionConfigAllGet
   * @summary Get All Configs
   * @request GET:/api/admin/text-extraction-config/all
   */
  getAllConfigsApiAdminTextExtractionConfigAllGet = (
    params: RequestParams = {},
  ) =>
    this.request<TextExtractionResponse[], HTTPValidationError>({
      path: `/api/admin/text-extraction-config/all`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Save and activate a text extraction configuration.
   *
   * @tags Text Extraction
   * @name SaveConfigApiAdminTextExtractionConfigSavePost
   * @summary Save Config
   * @request POST:/api/admin/text-extraction-config/save
   */
  saveConfigApiAdminTextExtractionConfigSavePost = (
    data: TextExtractionRequest,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/admin/text-extraction-config/save`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Validate a public shared folder link and return folder information.
   *
   * @tags Shared Folders
   * @name ValidateSharedFolderApiSharedFoldersValidatePost
   * @summary Validate Shared Folder
   * @request POST:/api/shared-folders/validate
   */
  validateSharedFolderApiSharedFoldersValidatePost = (
    data: SharedFolderValidateRequest,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/shared-folders/validate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Import files from a shared folder into the document system.
   *
   * @tags Shared Folders
   * @name ImportSharedFolderApiSharedFoldersImportPost
   * @summary Import Shared Folder
   * @request POST:/api/shared-folders/import
   */
  importSharedFolderApiSharedFoldersImportPost = (
    data: SharedFolderImportRequest,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, HTTPValidationError>({
      path: `/api/shared-folders/import`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Add a public SharePoint link without admin setup. This creates a temporary provider config and connection automatically.
   *
   * @tags Public SharePoint
   * @name AddPublicSharepointLinkApiPublicSharepointAddLinkPost
   * @summary Add Public Sharepoint Link
   * @request POST:/api/public-sharepoint/add-link
   */
  addPublicSharepointLinkApiPublicSharepointAddLinkPost = (
    data: PublicSharePointLinkRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/public-sharepoint/add-link`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Quick sync from a public SharePoint URL without creating a permanent connection. This is useful for one-time imports.
   *
   * @tags Public SharePoint
   * @name QuickSyncPublicSharepointApiPublicSharepointQuickSyncPost
   * @summary Quick Sync Public Sharepoint
   * @request POST:/api/public-sharepoint/quick-sync
   */
  quickSyncPublicSharepointApiPublicSharepointQuickSyncPost = (
    data: PublicSharePointSyncRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/public-sharepoint/quick-sync`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Validate a public SharePoint link and return parsed information.
   *
   * @tags Public SharePoint
   * @name ValidatePublicSharepointLinkApiPublicSharepointValidateLinkPost
   * @summary Validate Public Sharepoint Link
   * @request POST:/api/public-sharepoint/validate-link
   */
  validatePublicSharepointLinkApiPublicSharepointValidateLinkPost = (
    query: {
      /** Sharepoint Url */
      sharepoint_url: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/public-sharepoint/validate-link`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Validate a shared folder URL and discover available files.
   *
   * @tags Folder Syncs
   * @name ValidateFolderUrlApiFolderSyncsValidateUrlPost
   * @summary Validate Folder Url
   * @request POST:/api/folder-syncs/validate-url
   */
  validateFolderUrlApiFolderSyncsValidateUrlPost = (
    data: ValidateFolderUrlRequest,
    params: RequestParams = {},
  ) =>
    this.request<ValidateFolderUrlResponse, HTTPValidationError>({
      path: `/api/folder-syncs/validate-url`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all folder syncs for the current user.
   *
   * @tags Folder Syncs
   * @name ListFolderSyncsApiFolderSyncsGet
   * @summary List Folder Syncs
   * @request GET:/api/folder-syncs/
   */
  listFolderSyncsApiFolderSyncsGet = (params: RequestParams = {}) =>
    this.request<FolderSync[], HTTPValidationError>({
      path: `/api/folder-syncs/`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Create a new folder sync connection.
   *
   * @tags Folder Syncs
   * @name CreateFolderSyncApiFolderSyncsPost
   * @summary Create Folder Sync
   * @request POST:/api/folder-syncs/
   */
  createFolderSyncApiFolderSyncsPost = (
    data: FolderSyncCreate,
    params: RequestParams = {},
  ) =>
    this.request<FolderSync, HTTPValidationError>({
      path: `/api/folder-syncs/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a specific folder sync by ID.
   *
   * @tags Folder Syncs
   * @name GetFolderSyncApiFolderSyncsSyncIdGet
   * @summary Get Folder Sync
   * @request GET:/api/folder-syncs/{sync_id}
   */
  getFolderSyncApiFolderSyncsSyncIdGet = (
    syncId: string,
    params: RequestParams = {},
  ) =>
    this.request<FolderSync, HTTPValidationError>({
      path: `/api/folder-syncs/${syncId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update a folder sync connection.
   *
   * @tags Folder Syncs
   * @name UpdateFolderSyncApiFolderSyncsSyncIdPut
   * @summary Update Folder Sync
   * @request PUT:/api/folder-syncs/{sync_id}
   */
  updateFolderSyncApiFolderSyncsSyncIdPut = (
    syncId: string,
    data: FolderSyncUpdate,
    params: RequestParams = {},
  ) =>
    this.request<FolderSync, HTTPValidationError>({
      path: `/api/folder-syncs/${syncId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a folder sync connection.
   *
   * @tags Folder Syncs
   * @name DeleteFolderSyncApiFolderSyncsSyncIdDelete
   * @summary Delete Folder Sync
   * @request DELETE:/api/folder-syncs/{sync_id}
   */
  deleteFolderSyncApiFolderSyncsSyncIdDelete = (
    syncId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/folder-syncs/${syncId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Trigger manual sync for a folder sync connection.
   *
   * @tags Folder Syncs
   * @name TriggerFolderSyncApiFolderSyncsSyncIdSyncPost
   * @summary Trigger Folder Sync
   * @request POST:/api/folder-syncs/{sync_id}/sync
   */
  triggerFolderSyncApiFolderSyncsSyncIdSyncPost = (
    syncId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/folder-syncs/${syncId}/sync`,
      method: "POST",
      format: "json",
      ...params,
    });
}
